import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  TextField,
  Grid,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomTypography from "../../globalStyles/fonts";
const MarketDataModal = ({
  open,
  handleClose,
  onAddData,
  selectedDropskipTool,
}) => {
  const [formData, setFormData] = useState({
    category: "",
    avg_order_weight: "",
    avg_units_per_order: "",
    avg_order_value: "",
    cogs: "",
    unit_cogs: "",
    b2b_fulfillment_cost: "",
    ds_fulfillment_cost: "",
    merchandise: [
      { name: "", hs_code: "", duty_non_china: "", duty_rate_china: "" },
    ],
  });
  useEffect(() => {
    if (selectedDropskipTool) {
      setFormData(selectedDropskipTool);
    }
  }, [selectedDropskipTool]);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <DialogTitle>Market Data</DialogTitle>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <Divider />
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              disabled
              size="small"
              label="Category"
              name="category"
              value={formData.category}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              disabled
              size="small"
              label="Avg Order Weight"
              name="avg_order_weight"
              value={formData.avg_order_weight}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              disabled
              size="small"
              label="Avg Units per Order"
              name="avg_units_per_order"
              value={formData.avg_units_per_order}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              disabled
              size="small"
              label="Avg Order Value"
              name="avg_order_value"
              value={formData.avg_order_value}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              disabled
              size="small"
              label="COGS (%)"
              name="cogs"
              value={formData.cogs}
              fullWidth
              InputProps={{ endAdornment: "%" }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              disabled
              size="small"
              label="Unit COGS"
              name="unit_cogs"
              value={formData.unit_cogs}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              disabled
              size="small"
              label="B2B Fulfillment Cost"
              name="b2b_fulfillment_cost"
              value={formData.b2b_fulfillment_cost}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              disabled
              size="small"
              label="DS Fulfillment Cost"
              name="ds_fulfillment_cost"
              value={formData.ds_fulfillment_cost}
              fullWidth
            />
          </Grid>
          <CustomTypography
            style={{ paddingLeft: 2, paddingTop: 2, fontWeight: "500" }}
          >
            Merchandise
          </CustomTypography>
          <div style={{ padding: 10 }}>
            {formData.merchandise.map((item, index) => (
              <Paper
                variant="outlined"
                style={{ padding: 15, marginBottom: 10, width: "100%" }}
                key={index}
              >
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={6}>
                    <TextField
                      disabled
                      size="small"
                      label="Merchandise Name"
                      name="name"
                      value={item.name}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      disabled
                      size="small"
                      label="HS Code"
                      name="hs_code"
                      value={item.hs_code}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      disabled
                      size="small"
                      label="Duty Rate - Non China (%)"
                      name="duty_non_china"
                      value={item.duty_non_china}
                      fullWidth
                      InputProps={{ endAdornment: "%" }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      disabled
                      size="small"
                      label="Duty Rate China (%)"
                      name="duty_rate_china"
                      value={item.duty_rate_china}
                      fullWidth
                      InputProps={{ endAdornment: "%" }}
                    />
                  </Grid>
                </Grid>
              </Paper>
            ))}
          </div>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleClose} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MarketDataModal;
